export default "__VITE_ASSET__c8742a40__"